import React from 'react'
import ListSubheader from '@mui/material/ListSubheader'
import Typography from '@mui/material/Typography'

/**
 * Section header for grouped lists: small uppercase caption on a band slightly darker than the
 * paper, so a section title can't be mistaken for an option. Shared by the booking form's room
 * groups and the teleport picker's sections.
 */
export const listGroupHeaderSx = {
  px: 2,
  py: 0.75,
  display: 'block',
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  bgcolor: 'color-mix(in srgb, var(--sevv-bg-paper, #ffffff) 85%, var(--sevv-text-primary, #424242))',
} as const

export const ListGroupHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ListSubheader disableSticky disableGutters sx={{ p: 0, lineHeight: 'normal', bgcolor: 'transparent' }}>
    <Typography variant="caption" fontWeight={700} sx={listGroupHeaderSx}>
      {children}
    </Typography>
  </ListSubheader>
)

export default ListGroupHeader
